/**
 * Deployment dashboard.
 *
 * Every figure is shared. The legacy version could only report what the
 * current browser happened to hold, so two people comparing screens saw
 * different progress on the same deployment.
 */
import { formatNumberFr } from "@soi/contracts";
import { useDashboard } from "../lib/queries.js";
import { Kpis } from "../components/Kpis.js";

export function Dashboard() {
  const { data, isLoading } = useDashboard();

  return (
    <div className="gestion">
      <div className="admin-main">
        <div className="wrap">
          <section className="panel">
            <h1>Tableau de bord</h1>
            <p className="lede">
              Avancement du déploiement. Les volumes et les créneaux proviennent du planning validé
              (moteur v9) ; les réservations et les livraisons proviennent de la base partagée.
            </p>

            {isLoading && <p className="empty">Chargement…</p>}

            {data && (
              <>
                <Kpis
                  items={[
                    [formatNumberFr(data.totalSeats), "Postes au total"],
                    [
                      `${formatNumberFr(data.reservedSlots)} / ${formatNumberFr(data.totalSlots)}`,
                      "Créneaux réservés / disponibles",
                    ],
                    [
                      `${formatNumberFr(data.deliveredSeats)} / ${formatNumberFr(data.totalSeats)}`,
                      "Postes livrés / à livrer",
                    ],
                    [formatNumberFr(data.deploymentDays), "Journées de déploiement"],
                  ]}
                />

                {data.seatsDelta !== 0 && (
                  <p className="muted" data-testid="seats-delta">
                    Volume ajusté de {data.seatsDelta > 0 ? "+" : ""}
                    {formatNumberFr(data.seatsDelta)} poste
                    {Math.abs(data.seatsDelta) > 1 ? "s" : ""} par rapport aux{" "}
                    {formatNumberFr(data.plannedSeats)} prévus au planning, d'après les postes réels
                    relevés dans l'onglet Gestion des stocks.
                  </p>
                )}

                {data.calendarFailures > 0 && (
                  <div className="note" data-testid="calendar-failures">
                    <b>{formatNumberFr(data.calendarFailures)} rendez-vous</b> n'ont pas pu être
                    inscrits dans le calendrier Outlook de l'intervenant après plusieurs tentatives.
                    Les réservations restent valides et les créneaux restent occupés : seule la
                    copie dans Outlook manque. Vérifiez la configuration Microsoft Graph.
                  </div>
                )}

                {data.acceptanceFailures > 0 && (
                  <div className="note" data-testid="acceptance-failures">
                    <b>{formatNumberFr(data.acceptanceFailures)} rendez-vous</b> n'ont pas pu être
                    acceptés automatiquement dans la boîte du collaborateur. Le rendez-vous figure
                    bien dans les deux calendriers : le collaborateur a simplement reçu une
                    invitation à accepter lui-même. C'est le cas normal pour une adresse hors du
                    locataire Microsoft.
                  </div>
                )}
              </>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
